module.exports = __webpack_public_path__ + "components/weather-icon/static/nightlightsnow@3-9d23ea36c0c525e461b4bdd82683c04d.png";